import moment from 'moment';
import DatatableComponent from '../../helpers/DatatableComponent';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import { AvatarGroup, CircularProgress, Tooltip, Avatar, Button, Dialog, DialogContent, DialogTitle, Link, Paper, IconButton } from "@mui/material";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import { errorToast, successToast } from "../../helpers/Notification";
import SubmitTaskReportDialog from '../../helpers/SubmitTaskReport';
import StatusLayout from "components/Status";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ViewSubmittedTaskReport = ({ systemSettings, location, SetSelectedMenu, FetchDetails, loggedUser, resources }) => {
    const mainBackground = systemSettings?.mainBackground;

    const [count, setCount] = React.useState(0);
    const [team, setTeam] = useState([]);
    const [period, setPeriodState] = React.useState({
        startDate: moment().startOf("W"),
        endDate: moment().endOf("W"),
    });
    const [dataToEdit, setDataToEdit] = React.useState({});
    const [validationErrors, setValidationErrors] = React.useState({});
    const [taskId, setTaskId] = useState(null);
    const [loading, setLoading] = React.useState(false);
    const formRef = React.useRef(null);
    const [list, setList] = useState([]);

    const [openSubmitDialog, setOpenSubmitDialog] = useState(false);
    const [processedData, setProcessedData] = useState([]);
    const [viewChallenge, setViewChallenge] = React.useState(false);
    const [editChallenge, setEditChallenge] = React.useState(false);
    const { startDate, endDate, reportId } = location.state || {};
    const [resourceList, setResourceList] = useState([]);

    useEffect(() => {
        if (resources?.data) {
            setResourceList(resources.data);
        }
    }, [resources]);

    // const enrichAssignees = (assignees) => {
    //     const enrichedAssignees = assignees.map(assignee => ({
    //         ...assignee,
    //         Resource: resourceList.find(resource => resource.id === assignee.resourceId)
    //     }));
    //     return enrichedAssignees;
    // };

    const handleSubmitSuccess = () => {
        setCount((prev) => prev + 1);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "report/task",
            title: "Task Report"
        });
    }, []);

    const fetchResources = async () => {
        try {
            const data = await axios.get('api/resource/my-team');
            setTeam(data.data.data);
        } catch (error) {
        }
    };

    const history = useHistory();

    useEffect(() => {
        if (startDate && endDate && reportId) {
            const fetchData = async (startDate, endDate, reportId) => {
                const response = await FetchDetails(`/api/task/list/submitted-report?count=${count}&reportId=${reportId}`);

                if (response.status) {
                    setList(response.data.data);
                }

            };

            fetchData(startDate, endDate, reportId);
        }
    }, [startDate, endDate, reportId, FetchDetails, count]);

    const updateTask = async () => {
        if (!taskId) return errorToast('Server error. Please try again later');

        setLoading(true);
        try {
            successToast('Task updated successfully');

            setEditChallenge(false);
            setDataToEdit({});
            setValidationErrors({});
        } catch (error) {
            setValidationErrors({ description: error.message });
        } finally {
            setLoading(false);
            onSuccess();
        }
    };

    const renderChallengeModal = () => (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                <JoditEditorExample
                    htmlContent={dataToEdit?.overallStatus || ""}
                    onBlur={(str) =>
                        setDataToEdit((prev) => ({
                            ...prev,
                            overallStatus: str.target.value,
                        }))
                    }
                />
                {validationErrors.overallStatus && (
                    <div style={{ color: "red", marginTop: "0.5rem" }}>
                        {validationErrors.overallStatus}
                    </div>
                )}
            </div>
        </div>
    );

    const form = (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                updateTask().then((response) => {
                    if (response.status === 200) {
                        successToast("Task updated successfully");
                        setEditChallenge(false);
                        setDataToEdit({});
                        setValidationErrors({});
                    } else {
                        setValidationErrors(response.data);
                    }
                }).catch((error) => {
                    setValidationErrors({ description: error.message });
                });
            }}
        >
            {renderChallengeModal()}
            <div className="px-2" style={{ display: "flex", marginTop: "1rem" }}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => {
                                setEditChallenge(false);
                                setDataToEdit({});
                                setValidationErrors({});
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginLeft: "5px" }}
                            variant="contained"
                            type="submit"
                            sx={{
                                backgroundColor: mainBackground,
                                "&:hover": {
                                    backgroundColor: mainBackground,
                                },
                            }}

                        >
                            Save
                        </Button>
                    </>
                )}
            </div>
        </form>
    );


    useEffect(() => {
        fetchResources();

    }, [count]);



    const onSuccess = () => setCount((v) => v + 1);


    const columns = [
        {
            name: "name",
            label: "Task Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                ),
            },
        },
        {
            name: "taskInitiator",
            label: "Initiated By",
        },
        {
            name: "taskStartDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
            },
        },
        {
            name: "taskEndDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
            },
        },
        // {
        //     name: "assignedNames",
        //     label: "Assigned to",
        // },
        {
            name: 'assignedNames',
            label: 'Assigned to',
            options: {
                customBodyRender: (value, tableMeta) => {
                    const taskAssigneesStr = list[tableMeta.rowIndex]?.taskAssignees;
                    const downloadUrl = "your_download_url";

                    let assignees = [];
                    try {
                        assignees = JSON.parse(taskAssigneesStr || '[]');
                    } catch {
                        assignees = [];
                    }
                    const task_assignees = assignees.map(a => ({
                        ...a,
                        Resource: resourceList.find(r => r.id === a.resourceId)
                    }));

                    if (!task_assignees || task_assignees.length === 0) {
                        return "Unassigned";
                    }

                    const isMeAssigned = task_assignees.some(
                        (assignee) => assignee.Resource?.id === loggedUser?.Resource?.id
                    );

                    if (task_assignees.length === 1) {
                        const assigneeName = task_assignees[0].Resource?.names || "Unknown";
                        return isMeAssigned ? "Me" : assigneeName;
                    }

                    const assigneeNames = task_assignees.map((assignee) =>
                        assignee.Resource?.id === loggedUser?.Resource?.id ? "Me" : assignee.Resource?.names
                    );

                    const getAvatarLabel = (assignee) => {
                        if (assignee.Resource?.id === loggedUser?.Resource?.id) return "Me";
                        return assignee.Resource?.names?.charAt(0) || "U";
                    };

                    if (task_assignees.length >= 2) {
                        return (
                            <Tooltip
                                title={
                                    <div>
                                        {assigneeNames.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))}
                                    </div>
                                }
                                arrow
                            >
                                <AvatarGroup
                                    total={task_assignees.length}
                                    sx={{
                                        display: 'inline-flex',
                                        '& .MuiAvatar-root': {
                                            width: 24,
                                            height: 24,
                                            fontSize: 12
                                        }
                                    }}
                                >
                                    {task_assignees.slice(0, 2).map((assignee, idx) => {
                                        const hasProfile = !!assignee.Resource?.profile;
                                        const avatarProps = {
                                            key: idx,
                                            alt: assignee.Resource?.names,
                                            sx: { width: 24, height: 24, fontSize: 12 }
                                        };
                                        if (hasProfile) {
                                            avatarProps.src = `${downloadUrl}/${assignee.Resource.profile}`;
                                        }
                                        return (
                                            <Avatar {...avatarProps}>
                                                {getAvatarLabel(assignee)}
                                            </Avatar>
                                        );
                                    })}
                                </AvatarGroup>
                            </Tooltip>
                        );
                    }

                    return null;
                }
            }
        },
        {
            name: "overallStatus",
            label: "Overall Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    const getPreview = (html, len = 10) => {
                        if (!html) return '';
                        const cleanedHtml = html
                            .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
                            .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
                            .replace(/Jodit Editor\s*/g, '');
                        const div = document.createElement('div');
                        div.innerHTML = cleanedHtml;
                        const text = div.textContent || div.innerText || '';
                        return text.length > len ? text.substring(0, len) + '...' : text;
                    };
                    return (
                        <div>
                            {value ? (
                                <Link
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const projectName = tableMeta.rowData[1];
                                        setDataToEdit({ challenge: value, name: projectName });
                                        setViewChallenge(true);
                                    }}
                                    sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                                >
                                    {/* View Status */}
                                    {getPreview(value)}
                                </Link>
                            ) : (
                                <span style={{ color: '#888' }}>No Overall Status</span>
                            )}
                            {viewChallenge && dataToEdit.challenge === value && (
                                <Dialog
                                    open={viewChallenge}
                                    maxWidth="xs"
                                    fullWidth
                                    onClose={() => setViewChallenge(false)}
                                    PaperProps={{
                                        style: { padding: '1rem', borderRadius: '8px' },
                                    }}
                                >
                                    {/* <DialogTitle style={{ fontSize: '1rem' }}>
                                        <b>{dataToEdit.name ? `Overall Status for Task: ${dataToEdit.name}` : "Challenge"}</b>
                                    </DialogTitle> */}
                                    <DialogTitle>
                                        <div className={"flex items-center"}>
                                            <div className={"flex-grow font-bold text-lg"}>
                                                <b>{dataToEdit.name ? `Overall Status for Task: ${dataToEdit.name}` : "Challenge"}</b>
                                            </div>
                                            <IconButton onClick={() => setViewChallenge(false)}>
                                                <img
                                                    src={require("assets/icons/close.svg").default}
                                                    alt={"close"}
                                                />
                                            </IconButton>
                                        </div>
                                    </DialogTitle>
                                    <DialogContent>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: dataToEdit.challenge }}
                                            style={{ fontSize: '0.9rem', color: '#333' }}
                                        />
                                    </DialogContent>
                                    {/* <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                        <Button
                                            onClick={() => setViewChallenge(false)}
                                            sx={{
                                                color: 'primary.main',
                                                textTransform: 'none',
                                                fontWeight: 'normal',
                                            }}
                                        >
                                            Close
                                        </Button>
                                    </div> */}
                                </Dialog>
                            )}
                        </div>
                    );
                }
            },
        },
        {
            name: "status",
            label: "Task Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    let color =
                        status === "completed"
                            ? "success"
                            : status === "canceled"
                                ? "error"
                                : status === "pending review"
                                    ? "text-green-500"
                                    : status === "under review"
                                        ? "bg-secondary"
                                        : status === "missing information"
                                            ? "bg-black-500"
                                            : status === "forwarded"
                                                ? "bg-primary"
                                                : "info";
                    return (
                        <span
                            style={{ fontSize: "0.85rem" }}
                        >
                            <StatusLayout status={status} />
                        </span>

                    );
                },
            },
        },
    ];

    return (
        <div>
            <DatatableComponent
                columns={columns}
                pdf={true}
                // excel={true}
                searchfield={true}
                search={false}
                viewColumns={false}
                order={location.state?.order}
                onRowClick={(data, { rowIndex }) => {
                    try {
                        const taskAssignees = JSON.parse(list[rowIndex].taskAssignees || '[]');
                        const taskId = taskAssignees[0]?.taskId;
                        if (taskId) {
                            history.push(`/admin/task/${taskId}`);
                        } else {
                            console.error('No taskId found in taskAssignees');
                        }
                    } catch (error) {
                        console.error('Error parsing taskAssignees:', error);
                    }
                }}
                url={`/api/task/list/submitted-report?count=${count}&reportId=${reportId}`}
                processData={(data) => {
                    setProcessedData(data.data);
                    return data;
                }}
                onSubmitReport={() => {
                    setOpenSubmitDialog(true);
                }}


                title={`Tasks Report from ${startDate ? moment(startDate).format("YYYY-MM-DD") : "    "
                    } to ${endDate ? moment(endDate).format("YYYY-MM-DD") : ""
                    }`}

            />

            <SubmitTaskReportDialog
                open={openSubmitDialog}
                onClose={() => setOpenSubmitDialog(false)}
                onSuccess={handleSubmitSuccess}
                SubmitGeneralForm={async (url, formData) => {
                    try {
                        const response = await axios.post(url, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        return { status: response.status === 200, data: response.data };
                    } catch (error) {
                        return { status: false };
                    }
                }}

                startDate={moment(period.startDate).format("YYYY-MM-DD")}
                endDate={moment(period.endDate).format("YYYY-MM-DD")}
                loggedUser={loggedUser}
                resources={resources}
                processData={processedData}

            />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSubmittedTaskReport);